export { default } from './LoginModal';
